import React from 'react'

function LocationIcon() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M5.50062 0.04834C5.03467 0.04834 4.57328 0.140135 4.1428 0.318483C3.71233 0.49683 3.32121 0.758235 2.99177 1.08777C2.66234 1.4173 2.40106 1.8085 2.22285 2.23903C2.04463 2.66956 1.95298 3.13098 1.95313 3.59694C1.95313 6.16764 3.99583 9.33014 4.98143 10.7073C5.04057 10.79 5.11858 10.8574 5.20897 10.9038C5.29936 10.9503 5.39954 10.9745 5.50118 10.9745C5.60281 10.9745 5.70299 10.9503 5.79338 10.9038C5.88377 10.8574 5.96178 10.79 6.02093 10.7073C7.01092 9.33014 9.04923 6.16764 9.04923 3.59694C9.04937 3.13089 8.95768 2.66938 8.7794 2.23878C8.60112 1.80818 8.33973 1.41693 8.01019 1.08738C7.68064 0.757832 7.28939 0.496449 6.85879 0.318167C6.42819 0.139884 5.96667 0.0481955 5.50062 0.04834ZM5.50062 5.55494C5.12164 5.55494 4.75116 5.44256 4.43604 5.232C4.12092 5.02145 3.87532 4.72218 3.73029 4.37204C3.58525 4.0219 3.54731 3.63661 3.62124 3.26491C3.69518 2.8932 3.87768 2.55177 4.14567 2.28378C4.41365 2.0158 4.75509 1.8333 5.12679 1.75936C5.4985 1.68542 5.88378 1.72337 6.23392 1.8684C6.58406 2.01343 6.88333 2.25904 7.09389 2.57416C7.30444 2.88927 7.41682 3.25975 7.41682 3.63874C7.41682 4.14695 7.21494 4.63434 6.85558 4.9937C6.49623 5.35306 6.00883 5.55494 5.50062 5.55494Z"
          fill="#010101"
        />
      </g>
    </svg>
  )
}

export default LocationIcon
